import {SET_ENTITY_LIST, DEFAULT_ENTITY, PROFILE_DATA, STORE_GSTIN_GSTR2X, LOADER_STATUS, STORE_PERIOD, FILE_RETURN_PERIOD} from "./constants";

const initialState = {
   
    entityMasterList: [],
    defaultEntity:"",
    profileData: [],
    // startDate: new Date("2022/01/01"),
    // endDate: new Date("2022/03/01"),
    startDate: null,
    endDate: null,
    selectedGstin:[],
    fileReturnPeriod: null
};

const gstr2xCommonReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      }
      case DEFAULT_ENTITY:{
        return {
          ...state,
          defaultEntity: action.data
        }
      } 
        case SET_ENTITY_LIST:
            return {
              ...state,
              entityMasterList: action.payload
            }
         case PROFILE_DATA:
          return {
            ...state,
            profileData: action.profileData
          }
          case STORE_GSTIN_GSTR2X:
            return {
              ...state,
              selectedGstin:action.selectedGstin
            }
            case STORE_PERIOD:
              return {
                ...state,
                startDate:action.date.startDate,
                endDate: action.date.endDate
              } 
            case FILE_RETURN_PERIOD:
              return {
                ...state,
                fileReturnPeriod: action.date
              } 
            default: return state
        }
        
        
     
  };
export default gstr2xCommonReducer;